/**
 * Date-formatting helpers for the SPA.
 *
 * Audit 2026-10-19: 20 sites across the SPA inlined
 * `.toISOString().slice(0, 10)` for date-picker defaults, URL params,
 * CSV filenames, and date-based cache keys. Centralising means a future
 * tz-correctness PR has ONE place to change instead of 20.
 *
 * CURRENT SEMANTICS: UTC date. At 23:00 Eastern (04:00Z next day),
 * `toIsoDate(new Date())` returns tomorrow's UTC date. For the two sites
 * where this is user-visible (book.tsx date picker defaults, trial.tsx),
 * users near midnight local time can see an off-by-one. Fix is a
 * follow-up (`formatVenueDate(d, venueTz)` or a user-tz variant); for
 * now the helper preserves the prior behaviour exactly.
 */

/**
 * Format a Date as a UTC "YYYY-MM-DD" string. See module comment for
 * tz semantics + known off-by-one at midnight local time.
 */
export function toIsoDate(d: Date): string {
  return d.toISOString().slice(0, 10);
}

/**
 * Convenience: today's date as "YYYY-MM-DD" (UTC). Shorthand for
 * `toIsoDate(new Date())`.
 */
export function todayIso(): string {
  return toIsoDate(new Date());
}
